import * as actions from '../../Action/Tenant/Documents'

export const initialState = {
    documentData: null,    
    loaderStatus: false,
    documentDataFailure: null    
}

export default function reducer(state = initialState, action){    
    switch(action.type){
        case actions.DOCUMENTDATA : return documentData(state,action);
        case actions.DOCUMENTDATAFAILURE : return documentDataFailure(state,action)
        case actions.LOGGEDINLOADER: return loggedInLoader(state,action)
    default: return state
    }
}
const documentData = (state,action) => {
    return {
        ...state,
        documentData: action.payload
    }
}

const loggedInLoader =(state,action) => {
    return{
        ...state,
        loaderStatus: action.payload
    }
}

const documentDataFailure =(state,action)=>{
    return {
        ...state,
        documentDataFailure: action.payload
    }
}